import { render, staticRenderFns } from "./CommunityFinancesMember.vue?vue&type=template&id=2bc22df7&scoped=true&"
import script from "./CommunityFinancesMember.vue?vue&type=script&lang=js&"
export * from "./CommunityFinancesMember.vue?vue&type=script&lang=js&"
import style0 from "./CommunityFinancesMember.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CommunityFinancesMember.vue?vue&type=style&index=1&id=2bc22df7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc22df7",
  null
  
)

export default component.exports